import { createVNode as _createVNode } from "vue";
/**
 * @author xiezhixiong
 * @fileoverview 冠军赛16进4对战图
 */
import { defineComponent, ref, onMounted, onBeforeUnmount } from "vue";
import useRespondTo from "@/hooks/common/respond-to";
import WarSchedule from "../../common/war-schedule";
import { averageGroup, battleTeamNum } from './utils';
export default defineComponent({
  name: 'BattleMap16',
  props: {
    zone1Teams: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  emits: ['select'],
  setup(props, {
    emit
  }) {
    const raceScale = ref(0);
    const {
      isMobile
    } = useRespondTo();
    const resizeListener = () => {
      const innerWidth = window.innerWidth;
      // 赛事图原本大小 383，在 375 宽度的屏幕下，显示为 207 ，
      // 求当前屏幕宽度的缩放比
      raceScale.value = 207 * innerWidth / 375 / 383;
    };
    resizeListener();
    const attachResizeListener = () => {
      window.addEventListener('resize', resizeListener);
    };
    const detachResizeListener = () => {
      window.removeEventListener('resize', resizeListener);
    };
    onMounted(() => {
      attachResizeListener();
    });
    onBeforeUnmount(() => {
      detachResizeListener();
    });
    const handleSelect = record => {
      if (!record) {
        return;
      }
      emit('select', record);
    };
    return () => {
      const [firstVal, secondVal] = averageGroup(props.zone1Teams);
      if (isMobile.value) {
        return _createVNode("div", {
          "class": "battle-map-m"
        }, [_createVNode("div", {
          "class": "battle-map-race battle-map-m-race"
        }, [_createVNode("div", {
          "class": "battle-map-list battle-map-m-list",
          "style": {
            transform: `scale(${raceScale.value})`
          }
        }, [_createVNode("div", {
          "class": "battle-map-list-item"
        }, [_createVNode(WarSchedule, {
          "teams": props.zone1Teams,
          "teamNum": battleTeamNum(props.zone1Teams),
          "gridHeight": 27,
          "gridWidth": 130,
          "height": "700px",
          "offset": {
            top: 48,
            left: 30
          },
          "stroke": false,
          "onSelect": handleSelect
        }, null)])]), _createVNode("div", {
          "class": "battle-map-promotion battle-map-m-promotion"
        }, null)])]);
      }
      return _createVNode("div", {
        "class": "battle-map"
      }, [_createVNode("div", {
        "class": "battle-map-race"
      }, [_createVNode("div", {
        "class": "battle-map-list"
      }, [_createVNode("div", {
        "class": "battle-map-list-item"
      }, [_createVNode(WarSchedule, {
        "teams": firstVal,
        "teamNum": battleTeamNum(firstVal),
        "gridHeight": 52,
        "height": "700px",
        "offset": {
          top: 65,
          left: 38
        },
        "stroke": false,
        "onSelect": handleSelect
      }, null)]), _createVNode("div", {
        "class": "battle-map-list-item"
      }, [_createVNode(WarSchedule, {
        "teams": secondVal,
        "teamNum": battleTeamNum(secondVal),
        "gridHeight": 52,
        "height": "700px",
        "offset": {
          top: 65,
          left: -30
        },
        "onSelect": handleSelect,
        "reverse": true
      }, null)])]), _createVNode("div", {
        "class": "battle-map-promotion"
      }, null)])]);
    };
  }
});